module.exports = __webpack_public_path__ + "static/media/consumption_01.3b24a3bc.svg";